/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AppliedMethodology } from './AppliedMethodology';
import type { BacksolveSourceRow } from './BacksolveSourceRow';
import type { OPMBacksolveGPCRelation } from './OPMBacksolveGPCRelation';
import type { PublicCompanyAdjustmentStatus } from './PublicCompanyAdjustmentStatus';
export type ValuationApproachBacksolve = {
  readonly id?: number;
  valuation_approach: number;
  as_of_date?: string | null;
  metric?: ValuationApproachBacksolve.metric | null;
  adjustment_selected?: ValuationApproachBacksolve.adjustment_selected | null;
  opm_backsolve_gpc_relation_set?: Array<OPMBacksolveGPCRelation>;
  public_companies_status?: Array<PublicCompanyAdjustmentStatus>;
  deleted_opm_backsolve_gpc_relation_ids?: Array<number>;
  deleted_public_company_status_ids?: Array<number>;
  applied_methodologies?: Array<AppliedMethodology>;
  deleted_methodologies?: Array<number>;
  adjustment_type_selection: ValuationApproachBacksolve.adjustment_type_selection;
  source_rows: Array<BacksolveSourceRow>;
  name: string;
  readonly last_audit_event_id?: string | null;
  is_deleted?: boolean | null;
  readonly deleted_at?: string | null;
  securities_basket?: any;
  implied_equity_value?: string | null;
  enterprise_value?: string | null;
  maturity?: string | null;
  volatility?: string | null;
  adjust_for_market?: boolean;
  as_of_date_metrics?: any;
  percentile_selection_a?: number | null;
  percentile_selection_b?: number | null;
  specified_adjustment?: string | null;
  market_adjustment?: string | null;
  opm_backsolve_date?: string | null;
  backsolve_type?: ValuationApproachBacksolve.backsolve_type;
  gpc_approach?: number | null;
  volatility_source?: number | null;
};
export namespace ValuationApproachBacksolve {
  export enum metric {
    MARKET_CAP = 'Market Cap',
    ENTERPRISE_VALUE = 'Enterprise Value',
    LTM_REVENUE = 'LTM Revenue',
    LTM_EBITDA = 'LTM EBITDA',
    NTM_REVENUE = 'NTM Revenue',
    NTM_EBITDA = 'NTM EBITDA',
    SHARE_PRICE = 'Share Price',
  }
  export enum adjustment_selected {
    MEDIAN = 'Median',
    MEAN = 'Mean',
    _75TH_PERCENTILE = '75th Percentile',
    _25TH_PERCENTILE = '25th Percentile',
    SELECTION_A = 'Selection A',
    SELECTION_B = 'Selection B',
    SPECIFIED = 'Specified',
  }
  export enum adjustment_type_selection {
    ENTERPRISE_VALUE = 'Enterprise Value',
    EQUITY_VALUE = 'Equity Value',
  }
  export enum backsolve_type {
    STANDARD = 'standard',
    SECONDARY_TRANSACTIONS = 'secondary_transactions',
    MUTUAL_FUND_MARKS = 'mutual_fund_marks',
  }
}

